import { FC, useState } from 'react';

import IconComponent from '../IconComponent';

import { getRequestedLanguages } from '../../locale/languages';
import { ICONS } from '../../utils/enum/Icons';

interface Props {
    options: SelectOption[];
    selectedValue: SelectOption | null;
    onChange: (option: SelectOption) => void;
    label?: string;
    languagePath?: any;
}

export interface SelectOption {
    id?: number | string;
    value: number | string;
    label: string;
}

const SelectComponent: FC<Props> = ({ options, selectedValue, onChange, label, languagePath }) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="br_selectComponent">
            {label ? <label>{label}</label> : null}
            <div className="br_select-wrapper">
                <div className={`br_select ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                    <div className="br_select__trigger">
                        <span>
                            {selectedValue
                                ? languagePath
                                    ? (languagePath[selectedValue.label] as string)
                                    : selectedValue.label
                                : `${language.general.select}...`}
                        </span>
                        <div className="arrow">
                            <IconComponent icon={ICONS.chevron_down} />
                        </div>
                    </div>
                    <div className="br_custom-options">
                        {options.map((option, index) => {
                            return (
                                <span
                                    key={option.value}
                                    className={
                                        option.value == selectedValue?.value
                                            ? 'br_custom-option selected'
                                            : 'br_custom-option'
                                    }
                                    data-value={option.value}
                                    onClick={() => onChange(option)}
                                >
                                    {option.label}
                                </span>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectComponent;
